import { DatePipe } from '@angular/common';
import { Signal } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

export function maxDateValidator(maximumDate: Signal<string | undefined>, datePipe?: DatePipe): ValidatorFn {
  return (control) => {
    const maximumDateValue = maximumDate();
    const value = control.value;

    if (!value || !maximumDateValue) return null;

    const inputDate = new Date(value);

    if (inputDate > new Date(maximumDateValue)) {
      const date = datePipe ? datePipe.transform(maximumDateValue, 'dd-MM-yyyy') : maximumDateValue;
      return { maximumDate: { requiredDate: date } };
    }

    return null;
  };
}
